<!--
	ServiceCreateFields.svelte

    Initially the apiData will be empty - to be filled in by user

    This component displays the many fields of a Service.
    Set up as two blocks L/R which will stack in mobile views.
-->

<script>
    import { onMount } from 'svelte';
    import { formatNullFieldsToEmptyStrings, formatNullFieldsToEmptyArrays } from '../../common/utils.js';
    import { SERVICE_NAME, DESCRIPTION, PHONE, FAX, EMAIL, OP_HOURS, COVER_AREAS, WEBSITE } from '../../common/constants.js';

    // TCARE components
    import TaxonomyFieldsGroup from '../field-groups/TaxonomyFieldsGroup.svelte';
    import ServiceFieldsGroup1 from '../field-groups/ServiceFieldsGroup1.svelte';
    import ServiceFieldsGroup2 from '../field-groups/ServiceFieldsGroup2.svelte';
    import ServiceFieldsGroup3 from '../field-groups/ServiceFieldsGroup3.svelte';
    import ServiceFieldsGroup4 from '../field-groups/ServiceFieldsGroup4.svelte';
    import ServiceFieldsGroup5Coverage from '../field-groups/ServiceFieldsGroup5Coverage.svelte';

    // SMUI components

    export let store;                 // masterCreateService passed in from <ServiceCreatePage>

    $: apiData = $store.apiData;

    onMount(() => {
        // console.log('');
        // console.log('ServiceCreateFields onMount:');
        // console.log('$store:');
        // console.log($store);
    })

</script>

<style>
    /* already using tcare-form CSS */

	* :global(.label svg) {
		width: 20px !important;
		height: 20px !important;
		fill: var(--tcare-primary);
		outline: none;
	}


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>




<div class="service-details-create-fields tcare-form">
    <div class="spacer-h-25"></div>

    <TaxonomyFieldsGroup
        store={store}
        leftService={null}
        rightService={null}
        onCopyTaxonomy={null}
        isEditable={true}
        isOpen={true}
        showTcareTax1={true}
        showDiffs={true}
    />

    <ServiceFieldsGroup1
        bind:store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={true}
        isOpen={true}
        showDiffs={true}
    />

    <ServiceFieldsGroup2
        bind:store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={true}
        isOpen={true}
        showDiffs={true}
    />

    <ServiceFieldsGroup3
        bind:store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={true}
        isOpen={true}
        showDiffs={true}
    />
    
    <ServiceFieldsGroup4
        bind:store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={true}
        isOpen={true}
        showDiffs={true}
    />

    <!--
    <ServiceFieldsGroup5Coverage
        bind:store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={true}
        isOpen={true}
        showDiffs={true}
    />
    -->

</div>

